let ctx = null;
let master = null;
let music = null;

function ac() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = 0.5;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, dur, { type = "sine", gain = 0.12, delay = 0, slide = 0 } = {}) {
  const c = ac();
  const t = c.currentTime + delay;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(20, freq + slide), t + dur);
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(master);
  o.start(t);
  o.stop(t + dur + 0.05);
}

function noiseBurst(dur, { from = 3000, to = 300, gain = 0.2, delay = 0 } = {}) {
  const c = ac();
  const t = c.currentTime + delay;
  const len = Math.floor(c.sampleRate * dur);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  const src = c.createBufferSource();
  src.buffer = buf;
  const f = c.createBiquadFilter();
  f.type = "bandpass";
  f.Q.value = 0.8;
  f.frequency.setValueAtTime(from, t);
  f.frequency.exponentialRampToValueAtTime(to, t + dur);
  const g = c.createGain();
  g.gain.setValueAtTime(gain, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  src.connect(f).connect(g).connect(master);
  src.start(t);
}

function safe(fn) {
  try {
    fn();
  } catch {
    // Audio can be blocked (autoplay policy, extensions, missing devices).
    // Sounds are cosmetic — never let them break a click.
  }
}

export const sound = {
  blip() {
    safe(() => tone(1320, 0.07, { type: "square", gain: 0.045 }));
  },
  open() {
    safe(() => {
      tone(660, 0.1, { type: "triangle", gain: 0.08 });
      tone(990, 0.12, { type: "triangle", gain: 0.07, delay: 0.07 });
    });
  },
  bidBlast() {
    safe(() => {
      noiseBurst(1.1, { from: 400, to: 4500, gain: 0.22 });
      tone(70, 0.5, { type: "sine", gain: 0.3, slide: -30 });
      [392, 523, 659, 880].forEach((f, i) =>
        tone(f, 0.28, { type: "sawtooth", gain: 0.06, delay: 0.12 * i + 0.15 })
      );
      tone(1760, 0.4, { type: "sine", gain: 0.05, delay: 0.65 });
    });
  },
  toggleMusic() {
    const c = ac();
    if (music) {
      music.gain.gain.linearRampToValueAtTime(0.0001, c.currentTime + 1.2);
      const nodes = music;
      setTimeout(() => {
        nodes.oscs.forEach((o) => o.stop());
        clearInterval(nodes.seq);
      }, 1400);
      music = null;
      return false;
    }
    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, c.currentTime);
    g.gain.linearRampToValueAtTime(0.16, c.currentTime + 3);
    const filt = c.createBiquadFilter();
    filt.type = "lowpass";
    filt.frequency.value = 420;
    const lfo = c.createOscillator();
    lfo.frequency.value = 0.06;
    const lfoG = c.createGain();
    lfoG.gain.value = 220;
    lfo.connect(lfoG).connect(filt.frequency);
    const oscs = [lfo];
    [55, 55.4, 110.3, 164.8].forEach((f, i) => {
      const o = c.createOscillator();
      o.type = i < 2 ? "sawtooth" : "sine";
      o.frequency.value = f;
      const og = c.createGain();
      og.gain.value = i < 2 ? 0.5 : 0.18;
      o.connect(og).connect(filt);
      o.start();
      oscs.push(o);
    });
    filt.connect(g).connect(master);
    lfo.start();
    const scale = [220, 261.6, 329.6, 392, 440, 523.3];
    const seq = setInterval(() => {
      if (Math.random() < 0.7)
        tone(scale[Math.floor(Math.random() * scale.length)], 2.2, {
          type: "sine",
          gain: 0.035,
        });
    }, 2600);
    music = { gain: g, oscs, seq };
    return true;
  },
  musicOn() {
    return !!music;
  },
};